export default "/_next/static/chunks/fonts/Roboto Medium-7429a63c09f79a1760b0233e3e46f776.ttf";